export enum ModuleStatus {
  NotStart = 'notStart',
  InProgress = 'inProgress',
  Completed = 'completed',
  Skipped = 'skipped',
}
